module.exports = __webpack_public_path__ + "media/images/gallery/10s-d30db65e7f6471a0674240805ca49d79.jpg";